import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    // Listen for Turbo Stream actions
    document.addEventListener("turbo:before-stream-render", (event) => {
      const { target, action } = event.detail.newStream;

      if (action === "show" && target) {
        event.preventDefault();
        const modal = document.getElementById(target);
        if (modal) {
          $(modal).modal("show");
        }
      }
    });
  }
}
